<div class="max-w-input">
    <label class="text-sm text-shs-gray-1">@if(required) { <span>*</span> }{{ label }}</label>
    <sag-ui-filedrop
        [disabled]="disabled"
        [multiple]="true"
        accept=".pdf,.ppt,.msg,.docx,.doc,.png,.jpg,.jpeg,.mpeg"
        (change)="handleFileDrop($event)"
    >
        <p class="text-sm text-shs-gray-2">Drag and drop files here</p>
        <p class="text-sm text-shs-gray-2">or</p>
        <sag-ui-button size="sm" color="secondary">Browse files</sag-ui-button>
    </sag-ui-filedrop>
    <div class="flex flex-col gap-1 mt-2 w-full">
        @for (attachment of attachments; track $index) {
        <div class="grid grid-cols-[32px_auto_32px] my-2 items-center w-full">
            <span
                class="icon-link-extern text-shs-orange text-sm cursor-pointer"
                (click)="downloadAttachment(attachment.name)"
            ></span>
            <span class="text-sm text-font-primary truncate max-w-2/3">{{ attachment.name }}</span>
            @if (!disabled) {
            <span
                class="icon-close text-font-primary text-sm cursor-pointer"
                (click)="handleRemoveAttachment($index)"
            ></span>
            }
        </div>
        }
    </div>
</div>
